import * as React from 'react';
import './paymentStatusView.module.scss';
import { observer } from 'mobx-react';
import { PaymentStatus } from '../../../types/payments';
import { MaterialFontIcons } from '../../../../commonv3/components/atoms/icons/icons';
const classNames = require('classnames');

type PaymentStatusViewProps = {
    paymentStatus: PaymentStatus;
};

export const PaymentStatusView = observer(({ paymentStatus }: PaymentStatusViewProps) => {
    switch (paymentStatus) {
        case 'paid':
            return (
                <span>
                    <span styleName="icon-wrapper">
                        <MaterialFontIcons.CheckBox styleName={classNames('icon', 'unpaid')} />
                    </span>
                    <span styleName="payment-status-text">決済済み</span>
                </span>
            );
        case 'unpaid':
            return (
                <span>
                    <span styleName="icon-wrapper">
                        <MaterialFontIcons.Payment styleName={classNames('icon', 'paid')} />
                    </span>
                    <span styleName="payment-status-text">決済待ち</span>
                </span>
            );
        case 'refunded':
            return (
                <span>
                    <span styleName="icon-wrapper">
                        <MaterialFontIcons.Payment styleName={classNames('icon', 'paid')} />
                    </span>
                    <span styleName="payment-status-text">返金済み</span>
                </span>
            );
        case 'error':
            return (
                <span>
                    <span styleName="icon-wrapper">
                        <MaterialFontIcons.Warning styleName={classNames('icon', 'error')} />
                    </span>
                    <span styleName="payment-status-text">決済エラー</span>
                </span>
            );
        default:
            return (
                <span>
                    <span styleName="payment-status-text">不明</span>
                </span>
            );
    }
});
